@if (this.locations) {
<div class="d-flex justify-content-between btn-group"
     ngbDropdown
     [placement]="placement"
     role="group">
  @if (header) {
  <h2 class="title text-primary mb-0"
      i18n
      ngbDropdownToggle>
    {{ location?.displayName }}
  </h2>
  } @else {
  <div class="text-primary align-self-center"
       ngbDropdownToggle
       data-testid="location-picker-button">
    {{ location?.displayName || placeholder }}
  </div>
  }
  <div ngbDropdownMenu>
    <a ngbDropdownItem
       role="menuitem"
       [routerLink]="route">{{ placeholder }}</a>
    @for (location of locations; track location) {
    <a ngbDropdownItem
       role="menuitem"
       [routerLink]="route + '/' + [location.id]">{{ location.displayName }}</a>
    }
  </div>
</div>
}